export const defaultClick = eventObject => ({
  type: 'DEFAULT_CLICK',
  data: {
    eventName: 'Default Page Click',
    eventObject
  }
});

export const detectAdBlocker = eventObject => ({
  type: 'DETECT_AD_BLOCKER',
  data: {
    eventName: 'Detect Ad Blocker',
    eventObject
  }
});

export const newsletterSubmit = (eventObject = {}) => ({
  type: 'NEWSLETTER_SUBMIT',
  data: {
    eventName: 'Newsletter Submission',
    eventObject
  }
});

/* NOTE: This function is imported in other components in the codebase!
 * TODO: Replace any references with an event and have this function live elsewhere.
 */
export const fireActionTriggerCustomEvent = (
  eventName,
  data,
  target = document.querySelector('body')
) => {
  const event = new CustomEvent(eventName, data);
  target.dispatchEvent(event);
};
